// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconStepperPlus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
            <path
                fill="currentColor"
                d="M6.08928571,0.589285714 C6.08928571,0.270089286 5.81919643,0 5.5,0 C5.18080357,0 4.91071429,0.270089286 4.91071429,0.589285714 L4.91071429,4.91071429 L0.589285714,4.91071429 C0.270089286,4.91071429 0,5.18080357 0,5.5 C0,5.81919643 0.270089286,6.08928571 0.589285714,6.08928571 L4.91071429,6.08928571 L4.91071429,10.4107143 C4.91071429,10.7299107 5.18080357,11 5.5,11 C5.81919643,11 6.08928571,10.7299107 6.08928571,10.4107143 L6.08928571,6.08928571 L10.4107143,6.08928571 C10.7299107,6.08928571 11,5.81919643 11,5.5 C11,5.18080357 10.7299107,4.91071429 10.4107143,4.91071429 L6.08928571,4.91071429 L6.08928571,0.589285714 Z"
            />
        </svg>
    );
};

export default React.memo(IconStepperPlus);
